import { envConfig } from "@env/env-config";
import { IPrivacyPolicyModalResult, IPrivacyPolicyModalitems } from "./privacy-policy";

export class PrivacyPolicyModalController implements angular.IController {

    public static readonly $inject: Array<string> = ["$injector", "$uibModalInstance", "items"];

    /** @param close: 关闭模态窗口，传递一个结果 */
    private $close;
    /** @param dimiss: 取消模态窗口，传递一个原因 */
    private $dismiss;
    // 根地址路径
    private rootPath: string;
    // 客服邮箱
    private emailAddress: string;
    // 隐私权限状态
    private confirmPrivacyPolicy: boolean | undefined;
    // 网站平台类型
    private websiteCode: string;
    // 网站平台地址
    private domainNamePath: string;
    // 网站平台域名
    private domainName: string;
    // 本地localStage --PrivacyPolicy
    private cachePrivacyPolicy: boolean;

    constructor(
        public $injector: angular.auto.IInjectorService,
        public $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
        private items: IPrivacyPolicyModalitems
    ) {
        this.emailAddress = envConfig.supportEmail;
        
        this.rootPath = this.items.rootPath;
        this.confirmPrivacyPolicy = this.items.confirmPrivacyPolicy == undefined ? undefined : this.items.confirmPrivacyPolicy;
        this.cachePrivacyPolicy = this.items.cachePrivacyPolicy == undefined ? false : this.items.cachePrivacyPolicy;
        
        // 平台域名临时处理
        this.domainNamePath = envConfig.getHomePage(this.rootPath);
    }

    public $onInit() {
        
    }

    // cancel按钮点击
    public cancel() {
        // this.$uibModalInstance.dismiss({});
        this.$uibModalInstance.close({});
    }

    /**
     * @description 确认用户隐私权限
     * */
    public ok() {
        this.confirmPrivacyPolicy = true;
        const privacyPolicyModalResult: IPrivacyPolicyModalResult = {
            confirmPrivacyPolicy: this.confirmPrivacyPolicy,
            cachePrivacyPolicy: this.cachePrivacyPolicy?this.cachePrivacyPolicy:false
        }
        this.$uibModalInstance.close(privacyPolicyModalResult);
    }

    /**
     * @description 用户隐私权限确认修改 
     * */
    public changeCachePrivacyPolicy() {
        this.cachePrivacyPolicy = this.cachePrivacyPolicy ? this.cachePrivacyPolicy : false;
    }
}